import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import hmacHelper from "./HmacHelper.ts";
import { getExternalBaseUrl, EXTERNAL_CONFIG } from "./ExternalConfig.ts";

class ApplicationExternalService {
  private readonly api: AxiosInstance;
  private readonly clientId = EXTERNAL_CONFIG.clientId;
  private readonly clientSecret = EXTERNAL_CONFIG.clientSecret;
  private readonly contextPath = EXTERNAL_CONFIG.services.application;
  private readonly dropContextPath = EXTERNAL_CONFIG.dropContextPath;

  constructor() {
    this.api = axios.create({
      baseURL: getExternalBaseUrl()
    });

    this.api.interceptors.request.use((config) => this.signRequest(config));
  }

  private signRequest(config: InternalAxiosRequestConfig) {
    console.log("Signing external application request...");
    if (!config.url?.includes("/ext/")) return config;

    console.log("config url: ", config.url);
    console.log("config base url: ", config.baseURL);

    const url = new URL(config.url!, config.baseURL).toString();

    console.log("External url: ", url);

    const method = (config.method || "get").toUpperCase();
    const body = config.data || {};

    const hmacHeaders = hmacHelper.generateHmacHeaders(
      method,
      url,
      body,
      this.clientId,
      this.clientSecret,
      this.contextPath,
      this.dropContextPath
    );

    console.log("hmacHeaders: ", hmacHeaders);

    Object.entries(hmacHeaders).forEach(([key, value]) => {
      config.headers.set?.(key, value);
    });

    return config;
  }

  public createApplication(applicationData: any) {
    return this.api.post(
      "/application-service/ext/v2/applications",
      applicationData
    );
  }
}

export default new ApplicationExternalService();

